import React from 'react';
import { Plus } from 'lucide-react';
import ReelProjectCard from './ReelProjectCard';

export default function ReelCreatorHome({ projects, onNew, onContinue, loading }) {
  return (
    <div>
      <button onClick={onNew} disabled={loading} className="inline-flex min-h-14 w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 px-6 py-3 text-base font-bold text-white shadow-lg shadow-purple-950/30 hover:from-purple-500 hover:to-pink-500 focus:outline-none focus:ring-2 focus:ring-purple-300 disabled:opacity-50 sm:w-auto">
        <Plus size={21} /> NEW REEL
      </button>
      <div className="mt-8">
        <h2 className="text-lg font-semibold text-white">Your Reels</h2>
        {loading && projects.length === 0 ? (
          <p className="mt-4 text-sm text-gray-400">Loading your Reels…</p>
        ) : projects.length ? (
          <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
            {projects.map((project) => <ReelProjectCard key={project.id} project={project} onContinue={onContinue} />)}
          </div>
        ) : (
          <p className="mt-4 rounded-xl border border-gray-800 bg-gray-900 p-5 text-sm text-gray-400">Your first Reel will appear here.</p>
        )}
      </div>
    </div>
  );
}

